import BackIcon from '@mui/icons-material/ArrowBackIos';
import NextIcon from '@mui/icons-material/ArrowForwardIos';
import { Stack, IconButton, useTheme, TextField, InputAdornment, Box } from "@mui/material";
import { useMemo, useState } from 'react';
import { Close, Search } from '@mui/icons-material';

export default function Carousel({items, itemsPerPage, renderItem, filterItem, searchLabel, selected, onDeselect}){

    const [search, setSearch] = useState('')

    const [page, setPage] = useState(0)

    const perPage = useMemo(() => itemsPerPage || 1, [itemsPerPage])

    const filteredItems = () => {
        let copy = [...items];
        if(filterItem){
            copy = copy.filter(i => filterItem(i, search))
        }
        return copy
    }

    const pageCount = () => Math.ceil(filteredItems().length / perPage);

    const currentItems = () => {
        let copy = [...filteredItems()];
        let offset = page * perPage;
        let limit = offset + perPage;
        return copy.slice(offset, limit)
    }

    const next = n => {
        let p = page + n;
        p = p < 0 ? (pageCount() - 1) : p;
        p = p >= pageCount() ? 0 : p;
        return setPage(p);
    }

    const bulls = () => {
        let arr = []
        for(let i = 0; i < pageCount(); i++){
            arr.push(
                <Bull 
                    active={i === page}
                    onClick={() => setPage(i)}
                    key={i}
                />
            )
        }
        return arr
    }

    const handleSearch = e => {
        setSearch(e.target.value)
        setPage(0)
    }

    const paginate = pageCount() > 1


    if(items.length === 0) return <></>


    if(selected){

        return (

            <Stack direction="row" justifyContent="center" spacing={1}>
                
                {renderItem(selected)}

                <Box>
                    <IconButton onClick={onDeselect}>
                        <Close />
                    </IconButton>
                </Box>

            </Stack>
        );
    }
    

    return (

        <Stack spacing={2}>

            {filterItem &&
                <TextField
                    label={searchLabel || 'Rechercher'}
                    type='search'
                    value={search || ''}
                    onChange={handleSearch}
                    size='small'
                    variant='standard'
                    InputProps={{
                        startAdornment: <InputAdornment position='start'><Search/></InputAdornment>
                    }}
                />
            }

            <Stack direction='row' alignItems='center' justifyContent='center' spacing={1}>

                {paginate && 
                    <IconButton onClick={() => next(-1)}>
                        <BackIcon />
                    </IconButton>
                }

                <Stack direction='row' spacing={1}>
                    {currentItems().map(i => renderItem(i))}
                </Stack>

                {paginate && 
                    <IconButton onClick={() => next(1)}>
                        <NextIcon />
                    </IconButton>
                }

            </Stack>

            {paginate && 
                <Stack direction='row' justifyContent='center' spacing={1}>
                    {bulls()}
                </Stack>
            }

        </Stack>

    )
}


function Bull({active, onClick}){

    const theme = useTheme();

    const bull = {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: active ? theme.palette.primary.main : 'lightgrey',
        marginTop: 8,
        cursor: 'pointer'
    };

    return <div style={bull} onClick={onClick}></div>
}